import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { DEALER_ERRORS } from "constants/errors"
import { LocationTile } from "containers"
import { withRadium } from "higher-order-components"

class LocationsSectionMapLocationContainer extends PureComponent {
  componentDidMount() {
    setInterval(() => {
      this.forceUpdate()
    }, 100)
  }
  render() {
    return (
      <ul
        key={"LocationsSectionMapLocationContainer"}
        data-test={"location-list"}
        style={styles.locationsContainer}>
        {this.props.locations.length < 1 && (
          <li style={styles.messagePane}>
            <em>
              {this.props.fresh
                ? this.props.entryMessage || DEALER_ERRORS.FIRST_VISIT
                : DEALER_ERRORS.NO_DEALERS_FOUND}
            </em>
          </li>
        )}
        {this.props.locations.map((marker, index) => {
          const active = this.props.activeIndex === index
          return (
            <li
              key={index}
              ref={(c) => {
                if (active) this.props.getActiveTileRef(c)
              }}
              style={[
                index === 0 && { borderTop: "1px solid #d5d5d5" },
                this.props.activeIndex !== index &&
                this.props.activeIndex !== index + 1 && {
                  borderBottom: "1px solid #d5d5d5"
                },
                { display: "block" }
              ]}>
              <LocationTile
                index={index}
                disableCategories
                salesCTA={
                  this.props.salesCTA && {
                    ...this.props.salesCTA,
                    href: `${this.props.salesCTA
                      .href}?dealerCode=${marker.dealerCode}&dealerLocationId=${marker.id}`
                  }
                }
                serviceCTA={
                  this.props.serviceCTA && {
                    ...this.props.serviceCTA,
                    href: `${this.props.serviceCTA
                      .href}?dealerCode=${marker.dealerCode}&dealerLocationId=${marker.id}`
                  }
                }
                emailCTA={this.props.emailCTA}
                compact={this.props.compact}
                onClick={(event, callback) => {
                  // setting scroll to false (not needed for nz maps)
                  this.props.handleClickOnLocation(index, false, callback)
                }}
                mouseEnter={this.props.handleMouseEnterOnLocation}
                mouseLeave={this.props.handleMouseLeaveOnLocation}
                active={active}
                gtm={this.props.gtm}
                {...marker} />
            </li>
          )
        })}
      </ul>
    )
  }
}

LocationsSectionMapLocationContainer.defaultProps = {
  handleClickOnLocation: () => {}
}

LocationsSectionMapLocationContainer.propTypes = {
  locations: PropTypes.array,
  activeIndex: PropTypes.number,
  entryMessage: PropTypes.string,
  compact: PropTypes.bool,
  fresh: PropTypes.bool,
  handleMouseEnterOnLocation: PropTypes.func,
  handleMouseLeaveOnLocation: PropTypes.func,
  handleClickOnLocation: PropTypes.func,
  getActiveTileRef: PropTypes.func,
  salesCTA: PropTypes.object,
  serviceCTA: PropTypes.object,
  gtmMapping: PropTypes.object,
  emailCTA: PropTypes.object
}

const styles = {
  locationsContainer: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto"
  },
  messagePane: {
    height: "100%",
    flex: "1 1 auto",
    display: "flex",
    justifyContent: "center",
    padding: "3em",
    alignItems: "center",
    boxSizing: "border-box",
    fontSize: "120%",
    fontWeight: "200",
    color: "#AAAAAA",
    textAlign: "center"
  }
}

export default withRadium()(LocationsSectionMapLocationContainer)



// WEBPACK FOOTER //
// ./src/containers/map-location/locations-section.jsx